<template>
	<span v-if="visible">
		<el-card v-loading="!chainsOfThought.length" ref="terminal" class="terminal fade-in" style="max-width: 480px">
			<el-button
				@click="reset(true)"
				class="close"
				type="primary"
				style="font-size: 15px; z-index: 20"
				icon="el-icon-close"
				circle
			></el-button>
			<el-tabs style="margin-top: 40px" v-model="activeTab">
				<el-tab-pane
					:key="index"
					v-for="(chainOfThought, index) in chainsOfThought"
					:label="'Data ' + index"
					:name="index.toString()"
				>
					<div class="tabBody">
						<h3 style="text-align: center" v-if="chainOfThought.length">
							{{
								executionSummary ? "AI Agent - Chain of thought summary" : "AI Agent - Chain of thought"
							}}
						</h3>
						<el-divider></el-divider>
						<div :key="i" v-for="(data, i) in chainOfThought">
							<div v-if="data.numberInSequence">
								<div class="bottomMargin" v-if="!data.toolOutputData">
									<div class="terminalLine fade-in">
										<el-tag class="agentId" style="margin-bottom: 10px">
											<span
												class="colorDot"
												:style="{ backgroundColor: returnColor(data.aiAgentIntegrationId) }"
											></span>
											AI Agent: <b>{{ data.aiAgentIntegrationId }}</b>
										</el-tag>
										<span class="lineHeader">✦︎ Thought ~</span>
										<div style="margin-left: 3px">
											I should use <b>{{ data.toolName }}</b>
										</div>
									</div>
									<div class="terminalLineNoWrap fade-in">
										<span class="lineHeader">✦︎ Input ~ </span> Input data for
										<b>{{ data.toolName }}</b>
										<div v-if="data.toolInputData_parsed === 'unparsable'" style="margin-top: 10px">
											{{ truncateRawDisplayData(data.toolInputData) }}
										</div>
										<jsonInput
											style="margin-top: 10px"
											height="100"
											:json="JSON.stringify(data.toolInputData_parsed, null, 2)"
											v-if="data.toolInputData_parsed !== 'unparsable'"
										/>
									</div>
									<div class="terminalLineNoWrap fade-in">
										<span class="lineHeader">✦︎ Tool ~ </span> Using
										<b>{{ data.toolName }}</b>
										<div
											:class="
												'loading__bar ' +
												(data.stopLoadingAnimation
													? 'loading__barNotAnimated'
													: 'loading__barAnimated')
											"
										></div>
									</div>
								</div>
								<div class="bottomMargin" v-if="data.toolOutputData">
									<div class="terminalLineNoWrap fade-in">
										<el-tag class="agentId" style="margin-bottom: 10px">
											<span
												class="colorDot"
												:style="{ backgroundColor: returnColor(data.aiAgentIntegrationId) }"
											></span>
											AI Agent: <b>{{ data.aiAgentIntegrationId }}</b>
										</el-tag>
										<br />
										<span class="lineHeader">✦︎ Output ~ </span> Output data from
										<b>{{ data.toolName }}</b>
										<div
											v-if="data.toolOutputData_parsed === 'unparsable'"
											style="margin-top: 10px"
										>
											{{ truncateRawDisplayData(data.toolOutputData) }}
										</div>
										<jsonInput
											style="margin-top: 10px"
											height="100"
											:json="JSON.stringify(data.toolOutputData_parsed, null, 2)"
											v-if="data.toolOutputData_parsed !== 'unparsable'"
										/>
										<el-button
											v-if="
												data.toolOutputData_parsed !== 'unparsable' &&
												data.toolOutputData_parsed?.llmScreenshotView
											"
											@click="viewBrowserScreenShot"
											style="display: flex; margin-left: auto"
											type="text"
										>
											Launch agent browser view
										</el-button>
									</div>
								</div>
								<el-divider><i class="el-icon-s-tools"></i></el-divider>
							</div>
							<div v-if="data.finalOutput" class="terminalLineNoWrap fade-in">
								<el-tag class="agentId" style="margin-bottom: 10px">
									<span
										class="colorDot"
										:style="{ backgroundColor: returnColor(data.aiAgentIntegrationId) }"
									></span>
									AI Agent: <b>{{ data.aiAgentIntegrationId }}</b>
								</el-tag>
								<br />
								<span class="lineHeader">✦︎ Final Agent Output ~ </span>
								<div style="margin-top: 10px">{{ truncateRawDisplayData(data.finalOutput) }}</div>
								<el-divider><i class="el-icon-s-tools"></i></el-divider>
							</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</el-card>
		<agentBrowserScreenshotViewer ref="screenshotViewerModal" />
	</span>
</template>

<script>
import jsonInput from "./jsonInput.vue";
import agentBrowserScreenshotViewer from "./agentBrowserScreenshotViewer.vue";
import { returnColor } from "../utils/general.js";
export default {
	props: { executionSummary: Boolean },
	components: { jsonInput, agentBrowserScreenshotViewer },
	data() {
		return {
			userClosed: false,
			chainsOfThought: [],
			visible: false,
			activeTab: "0",
			isProcessing: false,
			queue: [],
		};
	},
	methods: {
		truncateRawDisplayData(str) {
			const maxLength = 700;
			if (typeof str !== "string") {
				try {
					str = JSON.stringify(str);
				} catch (e) {
					str = String(str); // Fallback for circular refs, symbols, etc.
				}
			}
			if (str == null) {
				return "";
			}
			return str.length <= maxLength ? str : str.slice(0, maxLength - 3) + "...";
		},
		returnColor(string) {
			return returnColor(string);
		},
		reset(userClosed) {
			this.visible = false;
			this.activeTab = "0";
			this.chainsOfThought = [];
			this.queue = [];
			this.isProcessing = false;
			if (userClosed) {
				this.userClosed = true;
			}
		},
		viewBrowserScreenShot() {
			this.$refs.screenshotViewerModal?.launch();
		},
		resetUserClosedView() {
			this.userClosed = false;
		},
		async pushOperationsIntoChainOfThought(metaData) {
			if (this.userClosed) {
				return;
			}
			this.visible = true;

			this.queue.push(metaData); // Push incoming event to the queue
			if (!this.isProcessing) {
				this.isProcessing = true; // Prevent multiple processors
				await this.processQueue(); // Process the queue
				this.isProcessing = false;
			}
		},
		async processQueue() {
			while (this.queue.length > 0) {
				const metaData = this.queue.shift(); // Get the first event in the queue
				const dataIndex = metaData.dataIndex ?? 0;
				//this.activeTab = dataIndex.toString();
				for (let i = 0; i < metaData.agent_c_o_t.length; i++) {
					if (!this.chainsOfThought[dataIndex]) {
						this.chainsOfThought.push([]);
					}

					const chain = metaData.agent_c_o_t[i];
					let latestEvent = chain[chain.length - 1];
					if (latestEvent?.toolOutputData && this.chainsOfThought[dataIndex].length > 0) {
						const relevantStartEvents = this.chainsOfThought[dataIndex].filter((each) => {
							return (
								each.aiAgentIntegrationId === latestEvent.aiAgentIntegrationId &&
								each.toolIntegrationId === latestEvent.toolIntegrationId &&
								!each.toolOutputData
							);
						});
						if (relevantStartEvents.length) {
							relevantStartEvents.forEach((startEvent) => {
								startEvent.stopLoadingAnimation = true;
							});
						} else {
							this.chainsOfThought[dataIndex][
								this.chainsOfThought[dataIndex].length - 1
							].stopLoadingAnimation = true;
						}
						await new Promise((resolve) => setTimeout(resolve, 1000)); // Delay for 1 second
					}

					this.chainsOfThought[dataIndex]?.push(latestEvent);

					if (latestEvent?.toolOutputData_parsed?.llmScreenshotView) {
						this.$refs.screenshotViewerModal?.addScreen(
							latestEvent?.toolOutputData_parsed?.llmScreenshotView,
							dataIndex
						);
					}

					// Ensure terminal scroll updates after each new event
					setTimeout(() => {
						let tab = document.getElementsByClassName("tabBody")[0];
						if (tab) tab.scrollTop = tab.scrollHeight;
					}, 0);
				}
				// Introduce a small delay between processing events
				await new Promise((resolve) => setTimeout(resolve, 500)); // Delay for smooth transitions
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import "../theme/baseStyles/index.scss";
.close {
	position: absolute;
	right: 20px;
	top: 20px;
}

.agentId {
	display: inline-flex;
	align-items: center;
}

.agentId b {
	margin-left: 5px;
}

.colorDot {
	height: 10px;
	width: 10px;
	margin-right: 10px;
	border-radius: 50%;
	border: 1px solid black;
}

.terminal {
	position: absolute;
	bottom: 0;
	height: 100%;
	width: 420px;
	z-index: 100000;
	opacity: 0.9;
	background-color: white;
	border: none;
	border-top-left-radius: 0px;
	border-bottom-left-radius: 0px;
	border-bottom-right-radius: 0px;
	font-size: 14px;
}

.tabBody {
	overflow-y: scroll !important;
	height: 71vh;
	padding-bottom: 20px;
	padding-right: 20px;
	overflow-x: hidden;
}

.terminalLine {
	display: flex;
	flex-wrap: wrap;
	vertical-align: middle;
	align-items: baseline;
	margin-bottom: 10px;
}

.terminalLineNoWrap {
	display: block;
	margin-bottom: 10px;
}

.terminalLine .content {
	margin-left: 5px;
}

.lineHeader {
	color: $--color-primary;
	font-weight: bold;
}

.bottomMargin {
	margin-bottom: 20px;
}

.fade-in {
	-webkit-animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
	animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

@-webkit-keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
@keyframes fade-in {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

.loading__bar {
	position: relative;
	height: 5px;
	width: 12rem;
	background-color: rgb(169, 169, 169);
	border-radius: 1em;
	overflow: hidden;
	margin-top: 20px;
}

.loading__barAnimated::after {
	position: absolute;
	top: 0;
	left: 0;
	content: "";
	width: 50%;
	height: 100%;
	background: linear-gradient(90deg, #fff5, rgba(230, 230, 230, 0.891));
	animation: loading-animation 1.3s infinite;
	border-radius: 1em;
}

.loading__barNotAnimated::after {
	position: absolute;
	top: 0;
	left: 0;
	content: "";
	width: 50%;
	height: 100%;
	background: rgb(169, 169, 169);
	border-radius: 1em;
}

@keyframes loading-animation {
	0% {
		left: -50%;
	}

	100% {
		left: 150%;
	}
}
</style>
